import React, { useState } from "react";
import { useSelector } from "react-redux";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import * as yup from "yup";
// eslint-disable-next-line no-unused-vars
import _ from "lodash";
import { ButtonRow, ConfirmModalContent, SeparateLine } from "styles/elements/main";
import { Button, GenericError, ModalComponent, ModalHeader, ToastMessage } from "components";
import trackAnalytics from "trackAnalytics";
import { deletePaymentMethod } from "modules/shared/api";
import axios from "lib/api";
import Spinner from "components/Spinner";
import { authorizedActionsSelector, getUserRoles } from "modules/auth/slice";
import RejectionList from "components/rejectionList";
import checkAuthorization from "modules/auth/helpers/checkAuthorization";
import { compareObjects } from "hooks/compareObjects";
import mapUiToData from "./mapUiToData";
import OthersSection from "./components/OthersSection";
import validationSchema from "./FormSchema";
import { PaymentMethods, PersonalInfo, WorkingInfo } from "./components";
import useFetchDriver from "./config/useFetchDriver";
import TruckOwner from "./components/TruckOwner";

function EditDriverProfile({ open, onClose, driverId }) {
    const [errors, setErrors] = useState({});
    const [backEndErorr, setBackendErorr] = useState(null);
    const [isLoading, setIsLoadoing] = useState(false);
    const [onSuccess, setOnSuccess] = useState(false);
    const [discardUpdate, setDiscardUpdate] = useState(false);
    const authorizedActions = useSelector(authorizedActionsSelector());
    const isAuthorizedToCreate = checkAuthorization(authorizedActions, "drivers", "create");
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager");
    const {
        setFetchedData,
        fetchedDdata,
        fetchedAttachments,
        setAttachments,
        initialDriver,
        paymentMethodId,
        fetchingDriver,
        objections,
    } = useFetchDriver(
        driverId,
        `${
            isSupplierPartner ? "suppliers" : "supplier"
        },paymentMethod,attachments,objections,objections.section,objections.item,ownedTrucks`
    );
    const handleDiscardUpdate = () => {
        setDiscardUpdate(!discardUpdate);
    };
    const handleCloseModal = () => {
        onClose();
        setDiscardUpdate(false);
        fetchingDriver();
    };
    const hanleEditedData = (e, fieldName) => {
        if (!fieldName) {
            const { name, value } = e?.target;
            setFetchedData({
                ...fetchedDdata,
                [name]: value,
            });
            yup.reach(validationSchema, name)
                .validate(value)
                .then(() => setErrors({ ...errors, [name]: "" }))
                .catch((err) => setErrors({ ...errors, [name]: err.message }));
        } else {
            setFetchedData({
                ...fetchedDdata,
                [fieldName]: e,
            });

            yup.reach(validationSchema, fieldName)
                .validate(e)
                .then(() => setErrors({ ...errors, [fieldName]: "" }))
                .catch((err) => setErrors({ ...errors, [fieldName]: err.message }));
        }
    };

    const handleEditedDataSubmition = async () => {
        setIsLoadoing(true);
        const changedData = compareObjects(initialDriver, fetchedDdata);
        trackAnalytics(`Driver_profile_submit_edit`, changedData);
        let mappedData;
        if (Object.keys(changedData).length === 0) {
            mappedData = await mapUiToData(
                fetchedDdata,
                fetchedDdata?.nationality,
                fetchedDdata?.id,
                fetchedDdata?.ownerPlateNumber,
                fetchedDdata?.isTruckOwner
            );
        } else {
            mappedData = await mapUiToData(
                changedData,
                fetchedDdata?.nationality,
                fetchedDdata?.id,
                fetchedDdata?.ownerPlateNumber,
                fetchedDdata?.isTruckOwner
            );
        }
        if (!fetchedDdata?.methodType) {
            deletePaymentMethod(paymentMethodId);
        }
        await axios
            .put(`drivers/${driverId}`, mappedData)
            .then(() => {
                setIsLoadoing(false);
                onClose();
                setOnSuccess(true);
                window.location.reload(true);
            })
            .catch((err) => {
                setIsLoadoing(false);
                setBackendErorr(err?.errors);
            });
    };

    return (
        <>
            <ModalComponent
                header={
                    <ModalHeader
                        entityName="Edit Driver"
                        entityId={driverId}
                        entityStatus={fetchedDdata?.qaStatus}
                    />
                }
                borderedHeader
                size="large"
                open={open}
                onClose={handleDiscardUpdate}
            >
                {Object.keys(objections).length > 0 && isAuthorizedToCreate && (
                    <RejectionList objections={objections} />
                )}
                <PersonalInfo
                    driverData={fetchedDdata}
                    isEidtSection
                    handleDataFroSubmit={hanleEditedData}
                    setDriverData={setFetchedData}
                    errors={errors}
                    uploadedAttachments={fetchedAttachments}
                    setAttachments={setAttachments}
                    objections={objections["Personal Info - Driver"] ?? null}
                    isAuthorizedToCreate={isAuthorizedToCreate}
                    isQARole={false}
                />

                <SeparateLine />
                <WorkingInfo
                    driverData={fetchedDdata}
                    isEidtSection
                    handleDataFroSubmit={hanleEditedData}
                    setDriverData={setFetchedData}
                    errors={errors}
                    uploadedAttachments={fetchedAttachments}
                    setAttachments={setAttachments}
                    objections={objections["Working Info - Driver"] ?? null}
                    isAuthorizedToCreate={isAuthorizedToCreate}
                    isQARole={false}
                />
                <SeparateLine />
                <PaymentMethods
                    driverData={fetchedDdata}
                    isEidtSection
                    handleDataFroSubmit={hanleEditedData}
                    setDriverData={setFetchedData}
                    errors={errors}
                    objections={objections["Payments Info - Driver"] ?? null}
                    isAuthorizedToCreate={isAuthorizedToCreate}
                    isQARole={false}
                />
                <SeparateLine />
                <OthersSection
                    driverData={fetchedDdata?.notes}
                    isEidtSection
                    handleDataFroSubmit={hanleEditedData}
                    isQARole={false}
                />
                <TruckOwner
                    driverData={fetchedDdata}
                    handleDataFroSubmit={hanleEditedData}
                    isEidtSection
                />
                {backEndErorr && <GenericError errorMassege={backEndErorr} />}
                <ButtonRow>
                    <Button
                        onChange={handleDiscardUpdate}
                        name="Cancel"
                        btnStyle="secondBtn"
                        type="button"
                    />
                    <Button
                        btnStyle={isLoading ? "disabled" : "primaryBtn"}
                        type="submit"
                        name={isLoading ? <Spinner /> : "Submit"}
                        disabled={isLoading}
                        icon={!isLoading && <AddCircleOutlineOutlinedIcon />}
                        onChange={handleEditedDataSubmition}
                    />
                </ButtonRow>
                {discardUpdate && (
                    <ModalComponent
                        header="Leave “Edit Driver” Page"
                        borderedHeader
                        isFooter
                        cancelBtn
                        submitBtn
                        open={discardUpdate}
                        submitBtnText="Leave"
                        onSubmit={handleCloseModal}
                        onClose={handleDiscardUpdate}
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
            </ModalComponent>
            {onSuccess && (
                <ToastMessage
                    name="driver"
                    type="success"
                    showToast={onSuccess}
                    setShowToast={setOnSuccess}
                    text="info edits have been submitted successfully."
                />
            )}
        </>
    );
}

export default EditDriverProfile;
